import { NgModule } from '@angular/core';
import { Keychain } from '@awesome-cordova-plugins/keychain/ngx';
import { Facebook } from '@ionic-native/facebook/ngx';
import { SignInWithApple } from '@ionic-native/sign-in-with-apple/ngx';

@NgModule({
  providers: [Keychain, SignInWithApple, Facebook],
})
export class AuthModule {}
